<label [for]="for" class="sh-form-label">
  <span [class.sh-u-required]="required" class="sh-form-label__text">
    <ng-content></ng-content>
  </span>
  @if (tooltip) {
    <span [pTooltip]="tooltip" class="sh-form-label__tooltip">
      <i class="pi pi-info-circle"></i>
    </span>
  }
</label>
